import React, { FC, useCallback } from 'react';
import { useSnackbarInfo } from '@mb/redux/selectors';
import { setSnackbarInfo } from '@mb/redux/slices';
import { MBSnackbar } from 'components/components/MBSnackbar';
import { useDispatch } from 'react-redux';

export const Snackbar: FC = () => {
  const snackbarInfo = useSnackbarInfo();
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(setSnackbarInfo({ ...snackbarInfo, isOpen: false }));
    setTimeout(() => dispatch(setSnackbarInfo(null)), 2000);
  }, [snackbarInfo]);

  return (
    <MBSnackbar
      id="product_catalog_message_box"
      open={snackbarInfo?.isOpen}
      message={snackbarInfo?.message}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={4000}
      onClose={handleClose}
      {...snackbarInfo}
    />
  );
};
